// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}





/* This is just a quick fix for the mini-editors for text areas */
.tox .tox-toolbar,
.tox .tox-toolbar__overflow,
.tox .tox-toolbar__primary {
  background-color: rgb(97, 97, 97) !important;
}



.dev-utils {


  h2{
    color: white;
   padding-bottom: 0.2em;
    border-bottom: 0.1em solid teal;
  }

  .single-util:after{
    content: "";
    width: 50%;
    margin: 0 auto;
    border-bottom: 0.2em solid white;
   
  }

  button {
    transition: all 300ms;

    border-radius: 1em;
    border: none;
    color: white;
    padding: 0.5em 1em;

    background-color: teal;
  }

  button:hover {
    transform: scale(1.1);
    background-color: rgb(51, 138, 138);

  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;;;;AAMA,iEAAiE;AACjE;;;EAGE,4CAA4C;AAC9C;;;;AAIA;;;EAGE;IACE,YAAY;GACb,qBAAqB;IACpB,+BAA+B;EACjC;;EAEA;IACE,WAAW;IACX,UAAU;IACV,cAAc;IACd,gCAAgC;;EAElC;;EAEA;IACE,qBAAqB;;IAErB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;;IAElB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,mCAAmC;;EAErC;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n\n\n\n/* This is just a quick fix for the mini-editors for text areas */\n.tox .tox-toolbar,\n.tox .tox-toolbar__overflow,\n.tox .tox-toolbar__primary {\n  background-color: rgb(97, 97, 97) !important;\n}\n\n\n\n.dev-utils {\n\n\n  h2{\n    color: white;\n   padding-bottom: 0.2em;\n    border-bottom: 0.1em solid teal;\n  }\n\n  .single-util:after{\n    content: \"\";\n    width: 50%;\n    margin: 0 auto;\n    border-bottom: 0.2em solid white;\n   \n  }\n\n  button {\n    transition: all 300ms;\n\n    border-radius: 1em;\n    border: none;\n    color: white;\n    padding: 0.5em 1em;\n\n    background-color: teal;\n  }\n\n  button:hover {\n    transform: scale(1.1);\n    background-color: rgb(51, 138, 138);\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
